module.exports = __webpack_public_path__ + "media/images/black_history_month/clock-c0dbe8caedb843339a7b8e84a5b90a02.svg";